import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ViewSettingsContextType {
  settingsContent: ReactNode | null;
  setSettingsContent: (content: ReactNode | null) => void;
}

const ViewSettingsContext = createContext<ViewSettingsContextType | undefined>(
  undefined
);

export const ViewSettingsProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [settingsContent, setSettingsContent] = useState<ReactNode | null>(
    null
  );

  return (
    <ViewSettingsContext.Provider
      value={{ settingsContent, setSettingsContent }}
    >
      {children}
    </ViewSettingsContext.Provider>
  );
};

export const useViewSettings = () => {
  const context = useContext(ViewSettingsContext);
  if (!context) {
    throw new Error('useViewSettings must be used within ViewSettingsProvider');
  }
  return context;
};
